"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// https://www.typescriptlang.org/docs/handbook/mixins.html
const applyMixins = (derivedCtor, baseCtors) => {
    baseCtors.forEach(baseCtor => {
        Object.getOwnPropertyNames(baseCtor.prototype).forEach(name => {
            // @ts-ignore
            Object.defineProperty(derivedCtor.prototype, name, Object.getOwnPropertyDescriptor(baseCtor.prototype, name));
        });
    });
};
exports.default = applyMixins;
//# sourceMappingURL=applyMixins.js.map